import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SITE as DEFAULT_SITE, ABOUT as DEFAULT_ABOUT, AREAS as DEFAULT_AREAS } from "@/data/content";

const ContentContext = createContext(null);

const fallback = {
  ...DEFAULT_SITE,
  about: { intro: DEFAULT_ABOUT.intro, paragraphs: DEFAULT_ABOUT.paragraphs, areas: DEFAULT_AREAS },
};

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(fallback);

  const refresh = () =>
    api.get("/content").then((r) => setContent({ ...fallback, ...r.data })).catch(() => {});

  useEffect(() => { refresh(); }, []);

  return (
    <ContentContext.Provider value={{ content, refresh }}>{children}</ContentContext.Provider>
  );
};

export const useContent = () => {
  const ctx = useContext(ContentContext);
  return ctx?.content || fallback;
};

export const useContentRefresh = () => {
  const ctx = useContext(ContentContext);
  return ctx?.refresh || (() => {});
};
